import React, { useEffect, useState } from 'react';
import { Col, Container, Row, Button, Form, InputGroup, Spinner, ButtonGroup } from 'react-bootstrap';
import '../../assets/css/component.css';
import CarouselLayout from '../../containers/Layouts/CarouselLayout/CarouselLayout';
import CardUnit from '../../components/CardUnit/CardUnit';
import Time from '../../assets/icons/Time';
import Location from '../../assets/icons/Location';
import Coupon from '../../assets/icons/Coupon';
import imageCar from '../../assets/images/category-car.png';
import { useHistory, useParams } from 'react-router-dom';
import withAuth from '../../services/withAuthProvider';
import toast from 'react-hot-toast';
import { format } from 'date-fns';
import CurrencyInput from 'react-currency-input-field';
import KonfirmasiMenangLelang from '../../components/Modals/KonfirmasiMenangLelang';
import ArtworkPending from './ArtworkPending';
import PageNotFound from '../Errors/PageNotFound';
import Echo from 'laravel-echo';
import { actionsLiveAuction } from '../../redux/liveAuction.slice';
import { userSelector } from '../../redux/auth.slice';
import { useDispatch, useSelector } from 'react-redux';
import ResultLelang from '../../components/Modals/ResultLelang';
import SpecialNIPL from '../../assets/icons/SpecialNIPL';
import Warning from '../../assets/icons/Warning';
import LockOff from '../../assets/icons/lock_off';
import LockOn from '../../assets/icons/lock_on';
import { isDate } from "../../utils/string";
import moment from "moment";
import SubstractIcon from '../../assets/icons/SubsctractIcon';
import PlusIcon from '../../assets/icons/PlusIcon';
import KonfirmasiBatalBid from '../../components/Modals/KonfirmasiBatalBid';
import { zeroPad } from 'react-countdown';
import 'moment/locale/id'
import OnlineAuctionSkeleton from '../../components/Skeleton/OnlineAuctionSkeleton';
moment.locale('id')

const defaultImage =
  'https://st3.depositphotos.com/23594922/31822/v/380/depositphotos_318221368-stock-illustration-missing-picture-page-for-website.jpg?forcejpeg=true';
const initialBid = {
  buyer: {},
  offer_price: 0,
  type: '-',
};

const initialDataModal = {
  lot_number: '',
  data_unit: {},
};

export default function CloseBidAuction() {
  const thisUser = useSelector(userSelector);
  const [SpecialNIPLToggle, setSpecialNIPLToggle] = useState(false);
  const [unitDetail, setUnitDetail] = useState(null);

  const { id, unitId } = useParams();
  const { push } = useHistory();
  const dispatch = useDispatch();

  const [isOpen, setIsOpen] = useState(false);
  const [result, setResult] = useState('LOADING');
  const [color, setColor] = useState('success');
  const [colorCancel, setColorCancel] = useState('danger');
  const [dataModal, setDataModal] = useState({ ...initialDataModal });

  // status
  const [disableBid, setDisabledBid] = useState('off');
  const [blockBid, setBlockBid] = useState('off');
  const [isProcess, setIsProcess] = useState('off');
  const [isCancelProcess, setIsCancelProcess] = useState('off')
  const [liveAuction, setLiveAuction] = useState('COMING');
  const [modalResult, setModalResult] = useState(false);
  const [FirstBid, setFirstBid] = useState(false);
  // dibuat false dulu
  const [detailUnitLoader, setDetailUnitLoader] = useState(true);
  const [detailBidderLoader, setDetailBidderLoader] = useState(true);

  // list
  const [data, setData] = useState({});
  const [auction, setAuction] = useState({});
  const [modalWinner, setModalWinner] = useState({});
  const [modalCancel, setModalCancel] = useState(false)
  const [images, setImages] = useState([]);
  const [nextLots, setNextLots] = useState([]);
  const [isLoadingNextLots, setIsLoadingNextLots] = useState(false);
  const [biddingList, setBiddingList] = useState([]);

  // bid
  const [offer, setOffer] = useState(0);
  const [error, setError] = useState('');
  const [transaction_id, setTransactionId] = useState('');
  const [highestBid, setHighestBid] = useState({ ...initialBid });
  const [multipleBid, setMultipleBid] = useState(0);
  const [counter, setCounter] = useState(null);

  // Handler
  const changeOffer = (val) => {
    const value = parseInt(val);
    let newError = '';
    if (!value) {
      newError = 'Penawaran tidak boleh kosong';
    } else if (value % multipleBid !== 0) {
      newError = `Penawaran harus kelipatan ${multipleBid.toLocaleString()}`;
    } else {
      newError = '';
    }
    setError(newError);
    setOffer(value);
  };
  const bidHandler = () => {
    if (disableBid === 'off') {
      setDisabledBid('on');
    } else {
      setDisabledBid('off');
    }
  };

  const toastError = (message) =>
    toast.error(message, {
      id: 'error-message',
      duration: 3000,
    });

  // Fetching
  // =================

  const postBid = async () => {
    setIsProcess('on');
    const params = {
      offer: offer,
    };
    if (error.length > 0) {
      toastError(error);
    } else {
      const postURL = `/api/v2/auction/${unitId}/close-bid`;

      const response = await withAuth.postDataWithAuth(postURL, params);

      if (response) {
        if (response?.status === 200) {
          toast.success('Penawaran telah dikirim', {
            id: 'success-message',
            duration: 3000,
          });
          getDetailAuctionBiddingList(unitId);
        } else {
          if(response?.data?.errors?.details === "Anda Tidak Terdaftar di lelang ini" || response?.data?.errors?.details === "Buyer tidak ditemukan"){
            setFirstBid(false)
            setBiddingList([]);
            setHighestBid({ ...initialBid })
          }
          toastError(response?.data?.errors?.details || 'Gagal melakukan penawaran');
        }
      } else {
        toastError(response?.data?.errors?.details || 'Gagal terhubung ke server');
      }
      setIsProcess('off');
    }
  };

  const cancelBid = async () => {
    setIsCancelProcess('on');
    const params = {
      offer: offer,
    };
    if (error.length > 0) {
      toastError(error);
    } else {
      const postURL = `/api/v2/auction/${unitId}/cancel-close-bid`;

      const response = await withAuth.postDataWithAuth(postURL, params);

      if (response) {
        if (response?.status === 200) {
          toast.success('Penawaran telah dibatalkan', {
            id: 'success-message',
            duration: 3000,
          });
          setModalCancel(false)
          getDetailAuctionBiddingList(unitId);
          setHighestBid({ ...initialBid })
          setFirstBid(false)
        } else {
          toastError(response?.data?.errors?.details || 'Gagal melakukan pembatalan');
        }
      } else {
        toastError(response?.data?.errors?.details || 'Gagal terhubung ke server');
      }
      setIsCancelProcess('off');
    }
  };

  // FETCH DATA V2
  const getDetailAuction = async () => {
    const params = {};
    const response = await withAuth.getDataWithAuth(`/api/v2/detail-auction/${id}`, params);
    if (response) {
      if (response?.status === 200) {
        const dataAuction = response.data.data;

        setAuction(dataAuction);
        setLiveAuction(dataAuction?.status);
        setMultipleBid(dataAuction?.unit_type?.multiple_bid || 0);
        if (dataAuction?.status !== 'STARTED') setIsOpen(false);

        if (dataAuction.is_have_nipl === 0 && dataAuction.is_non_deposit !== 1) {
          setBlockBid('on');
        } else {
          setBlockBid('off');
        }

        // if time bid, get detail from the previous unit page
        getDetailAuctionBiddingList(unitId);
        if (dataAuction?.winner_id === thisUser.id) {
          getDetailAuctionUnit(unitId, true);
        } else {
          getDetailAuctionUnit(unitId, false);
        }
      } else {
      }
    } else {
      FailedToConnect();
    }
  };
  const getDetailAuctionUnit = async (unit_id, winner) => {
    const imageURL = [];
    const params = {};
    const response = await withAuth.getDataWithAuth(`/api/new-unit/${unit_id}`, params);
    if (response) {
      if (response?.status === 200) {
        const dataAuction = response.data.data;

        if (dataAuction?.is_special_nipl) setSpecialNIPLToggle(dataAuction);
        else setSpecialNIPLToggle(false);

        setData(dataAuction);
        if (dataAuction.pictures.length > 0) {
          dataAuction.pictures.map((image, i) => imageURL.push({ image: image.image_url }));
          setImages(imageURL);
        }
        if (winner === true) {
          setModalWinner(dataAuction);
          showModal();
        } else {
          setDataModal((prev) => ({
            ...prev,
            data_unit: dataAuction,
          }));

          if (dataAuction?.unit_auction_status === 'NOT_SOLD' || dataAuction?.unit_auction_status === 'SOLD') {
            setIsOpen(true);
            setResult('LOADING');
          }

          if (dataAuction?.unit_auction_status === 'NOT_SOLD') {
            console.log('unit not sold');
            setResult('TIDAK TERJUAL');
          } else if (dataAuction?.unit_auction_status === 'SOLD') {
            console.log('unit sold');
            setResult('TERJUAL');
          }
        }
      } else {
        if (response?.status === 404) {
          console.error('response 404');
        } else {
          toast.error(response.data.message, {
            id: 'error-message',
            duration: 3000,
          });
        }
      }
    } else {
      FailedToConnect();
    }
    setDetailUnitLoader(false)
  };
  const getListNextLots = async () => {
    setIsLoadingNextLots(() => true);
    const response = await withAuth.getDataWithAuth(`/api/new-unit/${unitId}/related`);
    if (response) {
      if (response?.status === 200) {
        setNextLots(response?.data?.data);
      }
    } else {
      FailedToConnect();
    }
    setIsLoadingNextLots(() => false);
  };

  const getDetailAuctionBiddingList = async (unit_id) => {
    const params = {};
    const response = await withAuth.getDataWithAuth(`/api/v2/detail-auction-close-bid/${id}/detail-bidder/${unit_id}`, params);

    if (response)
      if (response?.status === 200) {
        const dataAuction = response.data.data;
        setUnitDetail(dataAuction);

        const dataList = dataAuction?.auction_progresses?.map((el) => ({
          ...el,
          offer_price: parseInt(el.offer_price),
        }));
        if (dataList.length) setFirstBid(true);
        const time_diff = dataAuction?.time_diff || 0;
        const last_price = parseInt(dataAuction?.last_price);
        let nextOffer = dataAuction?.last_price ? parseInt(dataAuction?.last_price) : parseInt(dataAuction?.base_price);

        if (dataAuction.auction_progresses.length > 0) {
          nextOffer = parseInt(last_price) + parseInt(dataAuction?.unit_type?.multiple_bid);
        }
        let newData = dataList.filter((el, idx) => idx !== 0);
        const newHighestBid = {
          buyer: dataList[0]?.buyer || {},
          offer_price: last_price,
          type: dataList?.length > 0 ? dataList[0]?.type : 'Harga Dasar',
          created_at: dataList[0]?.created_at
        };
        newData = checkSameBider(newData, 'API');
        localStorage.setItem(`listBidderTA-${id}-${unitId}`, JSON.stringify(newData));
        localStorage.setItem(`highBidTA-${id}-${unitId}`, JSON.stringify(newHighestBid));

        setBiddingList(newData);
        setHighestBid(dataAuction?.auction_progresses?.length > 0 ? newHighestBid : initialBid);
        setOffer(nextOffer);
        setCounter(time_diff);
      } else {
        FailedToConnect(response.data.message);
      }
    else FailedToConnect();
    setDetailBidderLoader(false)
  };

  function FailedToConnect(msg = 'Gagal terhubung ke server') {
    toast.error(msg, {
      id: 'error-message',
      duration: 3000,
    });
  }

  const secondsToTime = (secs) => {
    let hours = Math.floor(secs / (60 * 60));
    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);

    return zeroPad(hours) + ':' + zeroPad(minutes) + ':' + zeroPad(seconds);
  };

  function checkSameBider(bidList, access = '') {
    if (access !== '') {
      console.log('======= API ======= ');
    } else {
      console.log('======= SOCKET ======= ');
    }
    let checkSame = '';
    let newList = bidList?.map((bid) => {
      if (bid.offer_price === checkSame) {
        return 'DOUBLE';
      } else {
        checkSame = bid.offer_price;
        return bid;
      }
    });

    return newList.filter((bid) => bid !== 'DOUBLE');
  }

  const showModal = () => {
    dispatch(actionsLiveAuction.setModal({ modal: true }));
    setModalResult(true);
  };
  const closeModal = () => {
    dispatch(actionsLiveAuction.setModal({ modal: false }));
    setModalResult(false);
    getDetailAuction();
  };

  const callData = () => {
    getDetailAuction();
  };

  const handleClickCancelBid = () => setModalCancel(true)

  const handleIncreaseBid = () => {
    if (disableBid === 'on') setOffer((prev) => prev + data?.multiple_bid)
  }
  const handleDecreaseBid = () => {
    if (disableBid === 'on') setOffer((prev) => prev - data?.multiple_bid)
  }

  useEffect(() => {
    window.addEventListener('focus', callData);

    return () => {
      window.removeEventListener('focus', callData);
    };
  }, []);

  useEffect(() => {
    const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);

    if (counter === 0) {
      dispatch(actionsLiveAuction.setCurrentDataUnit({ unit: data }));
      setDataModal((prev) => ({
        ...prev,
        lot_number: auction?.auction_lane_name || '',
      }));
      if (liveAuction === 'STARTED') {
        setResult('LOADING');
        setIsOpen(true);
      }
    } else if (counter <= 3) {
      setBlockBid('on');
      setColor('secondary');
      setColorCancel('secondary')
    } else if (counter <= 5) {
      setColor('danger');
      setColorCancel('danger')
    } else if (counter <= 10) {
      setColor('orange');
      setColorCancel('danger')
    } else if (counter <= 15) {
      setColor('warning');
      setColorCancel('danger')
    } else if (counter > 15) {
      setColor('success');
      setColorCancel('danger')
    }

    return () => clearInterval(timer);
  }, [counter]);

  useEffect(() => {
    const bearer = localStorage.getItem('token');
    window.Echo = new Echo({
      broadcaster: 'pusher',
      key: process.env.REACT_APP_WS_KEY,
      cluster: process.env.REACT_APP_WS_CLUSTER,
      forceTLS: false,
      authEndpoint: `${process.env.REACT_APP_URL}broadcasting/auth`,
      auth: {
        headers: {
          Authorization: 'Bearer ' + bearer,
          Accept: 'application/json',
        },
      },
    });

    window.Echo.private(`auction.${id}`)
      .listen(`.auction.all`, (e) => {
        getDetailAuction();
      })
      // .listen(`.auction.bidder`, (e) => {
      //   if (e.auction_progress.stock_unit_id === unitId) {
      //     handleLatestBid(e);
      //   }
      // })
      .listen(`.auction.winner_posted`, (e) => {
        setTransactionId(e?.transaction?.id);
      });

    return () => {
      console.log('stop listen');
    };
  }, []);

  useEffect(() => {
    localStorage.removeItem(`highBidTA-${id}-${unitId}`);
    localStorage.removeItem(`listBidderTA-${id}-${unitId}`);
    getDetailAuction();
    getListNextLots();
  }, [unitId]);

  return (
    <>
      {
        !auction?.id ? <OnlineAuctionSkeleton /> : (
          <>
            {liveAuction === 'STARTED' ? (
              <>
                <div className="page h-100 pb-3">
                  <Container>
                    <Row>
                      <Col lg={5}>
                        <div className="box-border mt-15">
                          <div className="unit-slider w-100">
                            <CarouselLayout className="dots-left" dots={true}>
                              {images.length > 0 ? (
                                images.slice(0, 5).map((image, i) => (
                                  <div key={'img' + i} style={{ height: '222px' }}>
                                    <img
                                      className="with-background detail-unit-slider"
                                      src={image.image}
                                      style={{
                                        height: 'auto',
                                        width: '100%',
                                        objectFit: 'contain',
                                      }}
                                    />
                                  </div>
                                ))
                              ) : (
                                <div style={{ height: '222px' }}>
                                  <div
                                    className="with-background detail-unit-slider"
                                    style={{
                                      background: defaultImage ? `url(${defaultImage})` : '',
                                      height: '100%',
                                      width: '100%',
                                      objectFit: 'contain',
                                      minHeight: 200,
                                    }}
                                  ></div>
                                </div>
                              )}
                            </CarouselLayout>

                            {data?.unit_inspection_grade && (
                              <div className="grade-desktop d-none d-lg-block">
                                <p className="nomor-lot">
                                  Grade
                                  <span>{data?.unit_inspection_grade}</span>
                                </p>
                              </div>
                            )}
                            {/* mobile view */}
                            <div className="d-block d-lg-none position-absolute top-0 end-0">
                              <div className="badge-lot">
                                <span className="nomor-lot me-2">
                                  Lot {auction?.auction_lane_name && data?.lot_number ? auction?.auction_lane_name + data?.lot_number : '-'}
                                </span>
                                <span className="nomor-lot">Grade {data?.unit_inspection?.grade || '-'}</span>

                                {SpecialNIPLToggle.is_special_nipl === 'true' && (
                                  <span className="nomor-lot nipl">
                                    <span className="icon-nipl">
                                      <SpecialNIPL />
                                    </span>
                                    Special NIPL
                                  </span>
                                )}
                              </div>
                            </div>

                            {/* desktop view */}
                            {data?.unit_inspection?.grade && (
                              <div className="grade-unit-auction d-none d-lg-absolute">
                                Grade
                                <br />
                                <span className="grade-auction">{data?.unit_inspection?.grade}</span>
                              </div>
                            )}
                          </div>
                          <div className="d-none d-lg-block">
                            <h2 className="unit-name-auction">{data?.unit_name || ''}</h2>
                            <span className="unit-title">Highlight</span>
                            <div className="unit-highlight mt-2">
                              {data?.tags?.length > 0 ? data?.tags.map((row, i) => <span key={'tag' + i}>{row.name}</span>) : '-'}
                            </div>

                            <span className="unit-title">Detail Kendaraan</span>
                            <div className="bidder-data">
                              <div className="d-flex flex-wrap" style={{ gap: '8px' }}>
                                {data?.stock_informations?.length > 0
                                  ? data?.stock_informations
                                    ?.filter((el) => el.value !== '')
                                    .map(({ label, value }, idx) => (
                                      <div className="informasi-unit-auction" key={`information-${idx + 1}`}>
                                        <span className="title">{label}</span>
                                        <span className="value">
                                          {isDate(value)
                                            ? moment(value).format(
                                              "DD MMM YYYY"
                                            )
                                            : value !== "null" &&
                                              value
                                              ? value
                                              : "-"}
                                        </span>
                                      </div>
                                    ))
                                  : ''}
                                {data?.stock_documents?.length > 0
                                  ? data?.stock_documents
                                    ?.filter((el) => el.value !== '')
                                    .map(({ label, value }, idx) => (
                                      <div className="informasi-unit-auction" key={`information-${idx + 1}`}>
                                        <span className="title">{label}</span>
                                        <span className="value">{value || '-'}</span>
                                      </div>
                                    ))
                                  : ''}
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col lg={7}>
                        <div className="mt-15">
                          <div className="d-none d-lg-block">
                            <div className="badge-lot">
                              <span className="nomor-lot">
                                Lot {auction?.auction_lane_name && data?.lot_number ? auction?.auction_lane_name + data?.lot_number : '-'}
                              </span>
                              {SpecialNIPLToggle.is_special_nipl === 'true' && (
                                <span className="nomor-lot nipl">
                                  <span className="icon-nipl">
                                    <SpecialNIPL />
                                  </span>
                                  Special NIPL
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="d-flex align-items-center justify-content-between">
                            <span className="unit-title">Harga Dasar</span>
                            {/* <span className="d-inline d-lg-none unit-title">Bidder</span> */}
                          </div>
                          <div className="group">
                            <span
                              className="unit-price"
                              style={{
                                flex: '1',
                                textDecoration: data?.is_cancel_auction !== '0' ? 'line-through' : 'none',
                                textDecorationColor: 'red',
                                textDecorationThickness: '3px',
                              }}
                            >
                              Rp {data?.base_price !== undefined ? data?.base_price?.toLocaleString() : '0'}
                            </span>
                            {/* <span className="count-customer" style={{ textAlign: 'right' }}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M20 22H4V20C4 18.6739 4.52678 17.4021 5.46447 16.4645C6.40215 15.5268 7.67392 15 9 15H15C16.3261 15 17.5979 15.5268 18.5355 16.4645C19.4732 17.4021 20 18.6739 20 20V22ZM12 13C11.2121 13 10.4319 12.8448 9.7039 12.5433C8.97595 12.2417 8.31451 11.7998 7.75736 11.2426C7.20021 10.6855 6.75825 10.0241 6.45672 9.2961C6.15519 8.56815 6 7.78793 6 7C6 6.21207 6.15519 5.43185 6.45672 4.7039C6.75825 3.97595 7.20021 3.31451 7.75736 2.75736C8.31451 2.20021 8.97595 1.75825 9.7039 1.45672C10.4319 1.15519 11.2121 1 12 1C13.5913 1 15.1174 1.63214 16.2426 2.75736C17.3679 3.88258 18 5.4087 18 7C18 8.5913 17.3679 10.1174 16.2426 11.2426C15.1174 12.3679 13.5913 13 12 13Z"
                                fill="#646566"
                              />
                            </svg>
                            {auction?.nipls_count} Orang
                          </span> */}
                          </div>

                          <div className="bidder-list" style={{ marginTop: '20px' }}>
                            <div className="header d-flex flex-column-reverse flex-lg-row justify-content-between align-items-start align-items-lg-center gap-2">
                              <span className="title m-0" style={{ textAlign: 'left' }}>
                                Harga Penawaran Saat Ini
                              </span>
                              <div className="d-flex p-0 p-lg-3 timer-container">
                                <span className="timer w-100">
                                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                      d="M9.99935 18.3337C14.6017 18.3337 18.3327 14.6027 18.3327 10.0003C18.3327 5.39795 14.6017 1.66699 9.99935 1.66699C5.39698 1.66699 1.66602 5.39795 1.66602 10.0003C1.66602 14.6027 5.39698 18.3337 9.99935 18.3337Z"
                                      stroke="#C20102"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M10 5V10L13.3333 11.6667"
                                      stroke="#C20102"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                  {secondsToTime(counter)}
                                </span>
                              </div>
                            </div>
                            {
                              (FirstBid) && (
                                <>
                                  {/* ini untuk desktop view */}
                                  <div className="d-none d-lg-block px-4 pb-4">
                                    <div className="highest-bid border" style={{ borderRadius: '0.5rem' }}>
                                      <span className="bid-value">Rp {highestBid?.offer_price ? highestBid?.offer_price?.toLocaleString() : '-'}</span>
                                      <span className="bidder">
                                        {moment(highestBid?.created_at).format('DD MMMM YYYY (HH:mm)')}
                                        {/* {highestBid?.type === 'Timebid Bidder' && highestBid?.buyer?.user_id === thisUser.id
                                  ? 'Saya'
                                  : highestBid?.type || '-'} */}
                                      </span>
                                    </div>
                                  </div>
                                  {/* ini untuk mobile view */}
                                  <div className="d-block d-lg-none px-4 pb-4">
                                    <div className="highest-bid d-flex border" style={{ borderRadius: '0.5rem' }}>
                                      <span className="bid-value" style={{ fontSize: '20px' }}>
                                        Rp {highestBid?.offer_price ? highestBid?.offer_price?.toLocaleString() : '-'}
                                      </span>
                                      <span className="bidder" style={{ fontSize: '16px' }}>
                                        {moment(highestBid?.created_at).format('DD MMMM YYYY (HH:mm)')}
                                        {/* {highestBid?.type === 'Timebid Bidder' && highestBid?.buyer?.user_id === thisUser.id
                                  ? 'Saya'
                                  : highestBid?.type || '-'} */}
                                      </span>
                                    </div>
                                  </div>
                                </>
                              )
                            }
                            <div className="bidder-data ">
                              {biddingList.length > 0
                                ? biddingList
                                  ?.filter((bid) => bid?.offer_price !== highestBid?.offer_price)
                                  ?.map((bid, index) => (
                                    <div
                                      className={`bidder-item ${bid?.type === 'Timebid Bidder' && bid?.buyer?.user_id === thisUser.id && 'active'
                                        }`}
                                      key={`bid-${index}`}
                                    >
                                      <span className="bid-value">Rp {bid?.offer_price?.toLocaleString()}</span>
                                      <span className="bidder">
                                        {moment(bid?.created_at).format('DD MMMM YYYY (HH:mm)')}
                                        {/* {bid?.type === 'Timebid Bidder' && bid?.buyer?.user_id === thisUser.id ? 'Saya' : bid?.type || '-'} */}
                                      </span>
                                    </div>
                                  ))
                                : !FirstBid && (
                                  <div className="close-bid-no-bidding text-center d-flex justify-content-center flex-column" style={{ height: '250px', color: '#1E1E1F', gap: '10px' }}>
                                    <span className='fw-semibold' style={{ fontSize: '20px' }}>Anda belum melakukan penawaran apapun</span>
                                    <span className="mx-auto font-sm">Silahkan masukkan nilai penawaran anda untuk memulai penawaran</span>
                                  </div>
                                )}
                            </div>
                          </div>

                          <div className="d-none d-xl-block box-border form-bid"
                            style={{ marginTop: '20px', overflow: 'hidden' }}>
                            <BidControl
                              SpecialNIPLToggle={SpecialNIPLToggle}
                              unitDetail={unitDetail}
                              auction={auction}
                              disableBid={disableBid}
                              bidHandler={bidHandler}
                              counter={counter}
                              offer={offer}
                              changeOffer={changeOffer}
                              handleDecreaseBid={handleDecreaseBid}
                              handleIncreaseBid={handleIncreaseBid}
                              error={error}
                              thisUser={thisUser}
                              blockBid={blockBid}
                              isProcess={isProcess}
                              isCancelProcess={isCancelProcess}
                              data={data}
                              colorCancel={colorCancel}
                              handleClickCancelBid={handleClickCancelBid}
                              color={color}
                              postBid={postBid}
                              disabledSubstract={disableBid === 'off' || offer <= data?.base_price || detailUnitLoader || detailBidderLoader}
                              disabledPlus={disableBid === 'off' || detailUnitLoader || detailBidderLoader}
                              disabledCancel={disableBid === 'off' || blockBid === 'on' || isProcess === 'on' || isCancelProcess === 'on' || highestBid?.offer_price === 0 || detailUnitLoader || detailBidderLoader}
                              disabledTawar={disableBid === 'off' || blockBid === 'on' || isProcess === 'on' || isCancelProcess === 'on' || detailUnitLoader || detailBidderLoader}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>

                  {/* ini hanya tampil di mobile */}
                  <Container className="d-block d-lg-none">
                    <div className="box-lelang p-3" style={{ margin: '20px 0' }}>
                      <span className="unit-title mt-0">Highlight</span>
                      <div className="unit-highlight">
                        {data?.tags?.length > 0 ? data?.tags.map((row, i) => <span key={'tag' + i}>{row.name}</span>) : '-'}
                      </div>

                      <span className="unit-title">Detail Kendaraan</span>
                      <div className="bidder-data">
                        <div className="d-flex flex-wrap" style={{ gap: '4px' }}>
                          {data?.stock_informations?.length > 0
                            ? data?.stock_informations
                              ?.filter((el) => el.value !== '')
                              .map(({ label, value }, idx) => (
                                <div className="informasi-unit-auction" key={`information-${idx + 1}`}>
                                  <span className="title">{label}</span>
                                  <span className="value">
                                    {isDate(value)
                                      ? moment(value).format(
                                        "DD MMM YYYY"
                                      )
                                      : value !== "null" && value
                                        ? value
                                        : "-"}
                                  </span>
                                </div>
                              ))
                            : ''}
                          {data?.stock_documents?.length > 0
                            ? data?.stock_documents
                              ?.filter((el) => el.value !== '')
                              .map(({ label, value }, idx) => (
                                <div className="informasi-unit-auction" key={`information-${idx + 1}`}>
                                  <span className="title">{label}</span>
                                  <span className="value">{value || '-'}</span>
                                </div>
                              ))
                            : ''}
                        </div>
                      </div>
                    </div>
                  </Container>
                  <Container>
                    <Row>
                      <Col lg="12">
                        <div
                          className="box-lelang d-none d-lg-block"
                          style={
                            data?.current_stock_unit?.unit_type?.banner_url
                              ? {
                                marginTop: '20px',
                                background: `url(${data?.current_stock_unit?.unit_type?.banner_url})`,
                              }
                              : {
                                marginTop: '20px',
                                backgroundImage: `url(${imageCar})`,
                              }
                          }
                        >
                          <div className="group">
                            <div
                              style={{
                                flex: '1',
                                paddingLeft: '20px',
                                paddingTop: '10px',
                              }}
                            >
                              <span className="lelang-title">{auction?.name || '-'}</span>
                              <div className="lelang-date" style={{ color: '#1E1E1F' }}>
                                {(auction?.date_start && auction?.date_finish && auction?.date_start !== auction?.date_finish) ? (
                                  <span>
                                    {format(new Date(auction.date_start), 'dd MMM yyyy')} - {format(new Date(auction.date_finish), 'dd MMM yyyy')}
                                  </span>
                                ) : (
                                  auction?.date_start && auction?.time_start
                                    ? format(new Date(`${auction.date_start} ${auction.time_start}`), 'dd MMM yyyy')
                                    : '-'
                                )}
                              </div>
                            </div>
                            <div
                              style={{
                                flex: '1',
                                paddingLeft: '20px',
                                paddingTop: '10px',
                              }}
                            >
                              <div className="lelang-time">
                                <Time />{' '}
                                <span>
                                  {auction?.date_start && auction?.time_start
                                    ? format(new Date(`${auction.date_start} ${auction.time_start}`), 'HH:mm')
                                    : '-'}{' '}
                                  -{' '}
                                  {auction?.date_start && auction?.time_finish
                                    ? format(new Date(`${auction?.date_start} ${auction?.time_finish}`), 'HH:mm')
                                    : '-'}{' '}
                                  WIB
                                </span>
                              </div>
                              <div className="lelang-location">
                                <Location /> <span>{auction?.location_name || '-'}</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="box-lelang d-flex d-lg-none" style={{ marginTop: '20px' }}>
                          <div className="d-flex flex-column flex-lg-column">
                            <div
                              style={{
                                flex: '1',
                                paddingLeft: '20px',
                                paddingTop: '10px',
                              }}
                            >
                              <span className="lelang-title">{auction?.name || '-'}</span>
                              <div className="lelang-date" style={{ color: '#1E1E1F' }}>
                                {auction?.date_start && auction?.time_start
                                  ? format(new Date(`${auction.date_start} ${auction.time_start}`), 'dd MMM yyyy')
                                  : '-'}
                              </div>
                            </div>
                            <div
                              style={{
                                flex: '1',
                                paddingLeft: '20px',
                                paddingTop: '10px',
                              }}
                            >
                              <div className="lelang-time">
                                <Time />{' '}
                                <span>
                                  {auction?.date_start && auction?.time_start
                                    ? format(new Date(`${auction.date_start} ${auction.time_start}`), 'HH:mm')
                                    : '-'}{' '}
                                  -{' '}
                                  {auction?.date_start && auction?.time_finish
                                    ? format(new Date(`${auction?.date_start} ${auction?.time_finish}`), 'HH:mm')
                                    : '-'}{' '}
                                  WIB
                                </span>
                              </div>
                              <div className="lelang-location">
                                <Location /> <span>{auction?.location_name || '-'}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                  <Container>
                    <div className="produk-terkait w-100 overflow-auto">
                      <div>
                        <h3>Lot Lainnya</h3>
                      </div>
                      <div className="d-flex" style={{ gap: '1rem' }}>
                        {nextLots.length > 0 ? (
                          nextLots.map((item, idx) => {
                            const visibleInfos = (item?.unit_informations || []).filter(info => info.is_visible !== 0);
                            const year = visibleInfos.find((unit_information) => unit_information.label === 'Tahun');

                            const odometer = visibleInfos.find((unit_information) => unit_information.label === 'Odometer');

                            const transmisi = visibleInfos.find((unit_information) => unit_information.label === 'Transmisi');

                            const fuel = visibleInfos.find((unit_information) => unit_information.label === 'Bahan Bakar');

                            const validityPeriod = item?.unit_documents?.find((unit_document) => unit_document.label === 'STNK');

                            const unitDetail = {
                              police_number: item?.police_number,
                              year: year?.value,
                              odometer: odometer?.value,
                              transmisi: transmisi?.value,
                              fuel: fuel?.value,
                              validityPeriod: validityPeriod?.additional_value,
                            };
                            return (
                              <div
                                className="w-25"
                                key={'lot' + idx}
                                style={{ minWidth: '200px' }}
                                onClick={() => {
                                  push('/close-bid-auction/' + `${id}/` + item?.id);
                                  window.location.reload();
                                }}
                              >
                                <CardUnit
                                  timeLocation={true}
                                  lot_number={item?.lot_number || '-'}
                                  price={item?.base_price}
                                  tags={item?.tags || []}
                                  nama={item?.unit_name}
                                  location={item?.auction?.location_name}
                                  auction={item?.auction}
                                  pictures={item?.pictures}
                                  grade={item?.unit_inspection?.grade}
                                  unitType={item?.unit_type?.name}
                                  unitDetail={unitDetail}
                                ></CardUnit>
                              </div>
                            );
                          })
                        ) : (
                          <Col lg="2">Tidak ada Lot selanjutnya</Col>
                        )}
                      </div>
                    </div>
                  </Container>

                  {/* tampil saat mobile */}
                  <div
                    className="d-block d-xl-none position-fixed w-100 bottom-0 box-border form-bid"
                    style={{ marginTop: '20px', overflow: 'hidden', zIndex: 2 }}
                  >
                    <BidControl
                      SpecialNIPLToggle={SpecialNIPLToggle}
                      unitDetail={unitDetail}
                      auction={auction}
                      disableBid={disableBid}
                      bidHandler={bidHandler}
                      counter={counter}
                      offer={offer}
                      thisUser={thisUser}
                      changeOffer={changeOffer}
                      handleDecreaseBid={handleDecreaseBid}
                      handleIncreaseBid={handleIncreaseBid}
                      error={error}
                      blockBid={blockBid}
                      isProcess={isProcess}
                      isCancelProcess={isCancelProcess}
                      data={data}
                      colorCancel={colorCancel}
                      handleClickCancelBid={handleClickCancelBid}
                      color={color}
                      postBid={postBid}
                      disabledSubstract={disableBid === 'off' || offer <= data?.base_price || detailUnitLoader || detailBidderLoader}
                      disabledPlus={disableBid === 'off' || detailUnitLoader || detailBidderLoader}
                      disabledCancel={disableBid === 'off' || blockBid === 'on' || isProcess === 'on' || isCancelProcess === 'on' || highestBid?.offer_price === 0 || detailUnitLoader || detailBidderLoader}
                      disabledTawar={disableBid === 'off' || blockBid === 'on' || isProcess === 'on' || isCancelProcess === 'on' || detailUnitLoader || detailBidderLoader}
                    />
                  </div>
                </div>
              </>
            ) : (
              ''
            )}
            {liveAuction === 'COMING' || liveAuction === 'CLOSED' ? <ArtworkPending status={liveAuction} /> : ''}
            {liveAuction === 'NOT_FOUND' ? <PageNotFound></PageNotFound> : ''}
          </>
        )
      }
      {
        modalCancel &&
        <KonfirmasiBatalBid
          onCancel={() => setModalCancel(false)}
          onSubmit={cancelBid}
          isCancelProcess={isCancelProcess === 'on' ? true : false}
        />
      }
      {modalResult ? (
        <KonfirmasiMenangLelang
          continue={closeModal}
          checkout={() => push(`/pengaturan/transaksi/pembelian/${transaction_id}`)}
          data={modalWinner}
        />
      ) : (
        ''
      )}
      {isOpen ? <ResultLelang status={result} dataAuction={dataModal?.data_unit} /> : ''}
    </>
  );
}

const BidControl = ({
  SpecialNIPLToggle,
  unitDetail,
  auction,
  disableBid,
  bidHandler,
  counter,
  offer,
  changeOffer,
  handleDecreaseBid,
  handleIncreaseBid,
  error,
  thisUser,
  blockBid,
  isProcess,
  isCancelProcess,
  data,
  colorCancel,
  handleClickCancelBid,
  color,
  postBid,
  disabledSubstract,
  disabledPlus,
  disabledCancel,
  disabledTawar
}) => {
  const validatingClickButton = (callback) => {
    if(unitDetail?.id && data?.id){
      callback()
    }else{
      toast.error('Data masih dalam proses pemuatan, mohon tunggu beberapa saat dan coba lagi');
    }
  }
  return (
    <>
      {SpecialNIPLToggle && SpecialNIPLToggle.is_special_nipl === 'true' && (
        <>
          {unitDetail.remaining_nipls < SpecialNIPLToggle.number_of_nipl &&
            !unitDetail?.auction_progresses?.find((item) => Number(item.buyer_user_id) === thisUser.id) && (
              <div
                className="alert-nipl mobile-alert-nipl"
                style={{
                  top: '15px',
                  marginTop: -'35px',
                }}
              >
                <Warning color="#FF4D4D" /> Jumlah NIPL Anda tidak cukup untuk melakukan penawaran
              </div>
            )}
        </>
      )}
      <div className="d-flex tw-justify-between m-2">
        <span className="title-header">Tawar</span>{' '}
        {
          auction?.is_non_deposit !== 1 && (
            <div className="coupon-header d-flex">
              <Coupon />
              <p className="m-0">
                NIPL anda: <span>{unitDetail?.remaining_nipls}</span>
              </p>
            </div>
          )
        }
      </div>
      <div className='d-flex w-100 justify-content-end'>
        {SpecialNIPLToggle.is_special_nipl === 'true' && (
          <div className="coupon-footer d-flex">
            <Coupon />
            <p
              className="m-0"
              style={{
                borderRight: 'none',
              }}
            >
              <span>{SpecialNIPLToggle.number_of_nipl} NIPL</span> untuk menawar
            </p>
          </div>
        )}
      </div>
      <div className="group d-flex align-items-center">
        <div
          className="d-flex"
          style={{
            flexWrap: 'wrap',
            alignItems: 'center',
            textAlign: 'right',
            justifyContent: 'space-between',
            width: 'fit-content',
          }}
        >
          <div className="d-flex d-xl-none flex-column-reverse gap-1 align-items-center">
            {data?.is_cancel_auction !== '1' && (
              <>
                <Form.Check
                  type="switch"
                  id="custom-switch"
                  checked={disableBid === 'on' ? true : false}
                  onClick={() => validatingClickButton(bidHandler)}
                  disabled={counter <= 0 || counter === null}
                />
                <div className={`d-flex align-items-center`}>
                  <span
                    className="font-sm "
                    style={{
                      color: disableBid === 'on' ? '#2AB95E' : '#ff0000',
                    }}
                  >
                    {disableBid === 'on' ? 'Aktif' : 'Matikan'}
                  </span>
                </div>
              </>
            )}
          </div>{' '}
        </div>
        <div style={{ flex: '1', gap: '4px' }} className='d-flex flex'>
          <InputGroup>
            <InputGroup.Text id="basic-addon1">Rp</InputGroup.Text>
            <CurrencyInput
              id="hargaTawar"
              name="offer"
              className="form-control"
              placeholder="Masukan penawaran"
              disabled={disableBid === 'off' || blockBid === 'on'}
              value={offer}
              prefix="Rp "
              groupSeparator=","
              decimalSeparator="."
              readOnly
              allowDecimals={false}
              onValueChange={(value, name) => changeOffer(value)}
            />
          </InputGroup>
          <ButtonGroup size='sm' aria-label="Adjuster Offer" style={{ border: "1px solid #BEBFC2", borderRadius: '8px' }} >
            <Button
              variant="light"
              disabled={disabledSubstract}
              style={{ borderTopLeftRadius: '7px', borderBottomLeftRadius: '7px' }}
              onClick={() => validatingClickButton(handleDecreaseBid)}
            >
              <SubstractIcon />
            </Button>
            <Button
              variant="light"
              disabled={disabledPlus}
              style={{ borderLeft: "1px solid #BEBFC2", borderTopRightRadius: '7px', borderBottomRightRadius: '7px' }}
              onClick={() => validatingClickButton(handleIncreaseBid)}
            >
              <PlusIcon />
            </Button>
          </ButtonGroup>
          <small className="text-primary">{error}</small>
        </div>
      </div>

      {/* tampilan desktop*/}
      <div className="group d-xl-flex d-none flex-center tes" style={{ marginTop: '10px' }}>
        <div
          className="d-flex flex-column"
          style={{
            flexWrap: 'wrap',
            // alignItems: 'center',
            textAlign: 'left',
            justifyContent: 'space-between',
            maxWidth: '530px',
            width: '100%',
          }}
        >
          <div className="d-flex align-items-center">
            {data?.is_cancel_auction !== '1' && (
              <>
                <div className={`d-flex align-items-center `}>
                  <LockOn active={disableBid} />
                  <span
                    className="font-sm ml-1 me-4"
                    style={{
                      color: disableBid === 'off' ? '#ff0000' : '',
                    }}
                  >
                    Nonaktif
                  </span>
                </div>
                <Form.Check
                  className="ms-1"
                  type="switch"
                  id="custom-switch"
                  checked={disableBid === 'on' ? true : false}
                  onClick={() => validatingClickButton(bidHandler)}
                  disabled={counter <= 0 || counter === null}
                />
                <div className={`d-flex align-items-center`}>
                  <LockOff active={disableBid} />
                  <span
                    className="font-sm ml-1 me-4"
                    style={{
                      color: disableBid === 'on' ? '#2AB95E' : '',
                    }}
                  >
                    Aktif
                  </span>
                </div>
              </>
            )}
          </div>
          {SpecialNIPLToggle.is_special_nipl === 'true' && (
            <div className="coupon-footer d-flex" style={{ width: '170px', minWidth: 'unset' }}>
              <Coupon />
              <p className="m-0" style={{ border: 0 }}>
                <span>{SpecialNIPLToggle.number_of_nipl} NIPL</span> untuk menawar
              </p>
            </div>
          )}
        </div>
        <div className='d-flex' style={{ gap: '10px' }}>
          <Button
            className={`${disableBid === 'off' ? 'cancel-bid-off w-full' : 'cancel-bid-on'} text-nowrap w-100`}
            disabled={disabledCancel}
            onClick={() => validatingClickButton(handleClickCancelBid)}
            variant={colorCancel}
          >
            {isCancelProcess === 'on' ? <Spinner animation="border" /> : 'Cancel Penawaran'}
          </Button>
          <Button
            className={`${disableBid === 'off' ? 'bid-off' : 'bid-on'} w-100`}
            disabled={disabledTawar}
            onClick={() => validatingClickButton(postBid)}
            variant={color}
          >
            {isProcess === 'on' ? <Spinner animation="border" /> : 'Tawar'}
          </Button>
        </div>
      </div>

      {/* tampilan mobile */}
      <div className="group d-xl-none align-items-center" style={{ marginTop: '10px' }}>
        <Button
          className={`${disableBid === 'off' ? 'cancel-bid-off w-full' : 'cancel-bid-on'} text-nowrap w-100`}
          disabled={disabledCancel}
          onClick={() => validatingClickButton(handleClickCancelBid)}
          variant={colorCancel}
        >
          {isCancelProcess === 'on' ? <Spinner animation="border" /> : 'Cancel Penawaran'}
        </Button>
        <Button
          className={`${disableBid === 'off' ? 'bid-off' : 'bid-on'} w-100`}
          disabled={disabledTawar}
          onClick={() => validatingClickButton(postBid)}
          variant={color}
        >
          {isProcess === 'on' ? <Spinner animation="border" /> : 'Tawar'}
        </Button>
      </div>
    </>
  )
}